import {
  AssignGridDataType,
  ColumnHeaderType,
  GridOptionType,
  IAgriGridType,
  LoggedUserType,
  Polygon,
  SelectOptionType,
  UserType,
} from '../../utils/Types';
import {
  CLICK_ACTIONS,
  LIST_VIEW_ITEM,
  TABLE_SORT_DESC,
} from '../../utils/Constant';
import {
  blankValueGetter,
  getLatLngArray,
  nameValueGetterSmall,
} from '../../utils/Util';
import {
  updateListViewItemsStatus,
  updateSelectedMenu,
} from '../../features/dashboardSlice';
import { NavigateFunction } from 'react-router-dom';
import { ThunkDispatch } from 'redux-thunk';
import { updateSelectedCandidate } from '../../features/assignGridSlice';
import { toast } from 'react-toastify';
import { STATE_ACCESS_ROLES } from '../../utils/RBAC';

export const actionValueGetter = (data: AssignGridDataType, field?: string) => {
  if (
    !data[field as keyof AssignGridDataType] ||
    data[field as keyof AssignGridDataType] === 'null'
  ) {
    return 'Assign Grid';
  } else {
    return 'View Details';
  }
};

export const AssignGridColumnHeader: ColumnHeaderType[] = [
  {
    name: 'Candidate Id',
    field: 'candidateuniqueid',
    sortable: false,
    valueGetter: blankValueGetter,
    showProfilePhoto: true,
  },
  {
    name: 'Employee Id',
    field: 'employeeuniqueid',
    sortable: false,
    valueGetter: blankValueGetter,
  },
  {
    name: 'Employee Name',
    field: 'employeeName',
    sortable: false,
    toolTipAfter: 25,
    valueGetter: nameValueGetterSmall,
  },
  {
    name: 'Pincode',
    field: 'pincode',
    sortable: false,
    valueGetter: blankValueGetter,
  },
  {
    name: 'Mobile Number',
    field: 'mobilenumber',
    sortable: false,
    valueGetter: blankValueGetter,
  },
  {
    name: 'Assigned Grid',
    field: 'assignedgrids',
    sortable: true,
    valueGetter: blankValueGetter,
  },
  {
    name: 'Assigned By',
    field: 'assignedbyname',
    sortable: true,
    toolTipAfter: 25,
    valueGetter: blankValueGetter,
  },
  {
    name: 'Actions',
    field: 'assignedgrids',
    sortable: true,
    clickable: true,
    action: CLICK_ACTIONS.ASSIGN_GRID,
    valueGetter: actionValueGetter,
  },
];

export const createPolygon = (latLngArray: any) => {
  const polygon = new google.maps.Polygon({
    paths: latLngArray,
    strokeColor: '#FF0000',
    strokeOpacity: 0.8,
    strokeWeight: 2,
    fillColor: '#FF0000',
    fillOpacity: 0.35,
  });
  return polygon;
};

export const updatePolygonAndMap = (
  polygonPositionsArray: any,
  mapInstance: google.maps.Map
) => {
  const polygonArray: Polygon[] = [];
  try {
    if (polygonPositionsArray && polygonPositionsArray.length > 0) {
      for (const element of polygonPositionsArray) {
        const polygon = createPolygon(element);
        if (polygon.setMap) {
          polygon.setMap(mapInstance);
        }
        polygonArray.push(polygon);
      }
      mapInstance.setCenter(
        polygonPositionsArray[polygonPositionsArray.length - 1][2] ||
          polygonPositionsArray[polygonPositionsArray.length - 1][0]
      );
      if (polygonPositionsArray.length === 1) {
        mapInstance.setZoom(12);
      } else if (polygonPositionsArray.length > 1) {
        mapInstance.setZoom(11);
      }
    }
  } catch (err) {}
  return polygonArray;
};
export const clearAddedPolygon = (
  mapInstance: google.maps.Map | null,
  addedPolygons: Polygon[] | undefined
) => {
  if (mapInstance && addedPolygons && addedPolygons.length > 0) {
    for (const element of addedPolygons) {
      element.setMap(null);
    }
  }
};

export const onTaskAction = (
  previousScreenData: any,
  navigate: NavigateFunction,
  dispatch: ThunkDispatch<any, any, any>,
  setViewTask: (value: boolean) => void,
  getTaskList: () => void
) => {
  if (previousScreenData) {
    switch (previousScreenData?.action) {
      case CLICK_ACTIONS.SHOW_TRACK_LOCATION:
        navigate('/track-location', { state: previousScreenData });
        dispatch(updateSelectedMenu('track-location'));
        break;

      case CLICK_ACTIONS.SHOW_APPLY_REIMBURSEMENT:
        navigate('/apply-reimbursement', { state: previousScreenData });
        dispatch(updateSelectedMenu('apply-reimbursement'));
        break;

      case CLICK_ACTIONS.CLOSE_VIEW_TASK:
        setViewTask(false);
        getTaskList();
        dispatch(updateListViewItemsStatus(LIST_VIEW_ITEM.LIST_ITEMS));
        break;

      default:
        break;
    }
  }
};

export const onTableAction = (
  param: any,
  header: ColumnHeaderType,
  setSelectedTask: any,
  setViewTask: (value: boolean) => void,
  dispatch: ThunkDispatch<any, any, any>
) => {
  if (header.action === CLICK_ACTIONS.VIEW_TASK) {
    setSelectedTask(param);
    setViewTask(true);
    dispatch(updateListViewItemsStatus(LIST_VIEW_ITEM.VIEW_ITEM));
  }
};
export const getAssignGridDataRequest = (
  selectedFilter: any,
  pageSize: number,
  currentPage: number,
  userDetails: UserType,
  user: LoggedUserType
) => {
  const params: any = {
    pageLimit: pageSize,
    pageNumber: currentPage,
    sort: TABLE_SORT_DESC,
  };
  if (selectedFilter?.employeeId) {
    params.employeeId = selectedFilter?.employeeId;
  }
  if (
    STATE_ACCESS_ROLES.includes(user?.roleId) &&
    userDetails?.reportingZones?.length
  ) {
    params.zone = Number(userDetails?.reportingZones[0]);
  }
  if (selectedFilter?.employeeName) {
    params.employeeName = selectedFilter?.employeeName;
  }
  if (selectedFilter?.state?.value)
    params.state = Number(selectedFilter.state.value);
  if (selectedFilter?.city?.value)
    params.city = Number(selectedFilter.city.value);
  if (selectedFilter?.district?.value)
    params.district = Number(selectedFilter.district.value);
  if (selectedFilter?.zone?.value)
    params.zone = Number(selectedFilter.zone.value);
  if (selectedFilter?.roleId?.value)
    params.roleId = selectedFilter.roleId.value;
  if (selectedFilter?.assignStatus?.value)
    params.assignStatus = selectedFilter.assignStatus.value;
  return params;
};

/**
 * Update show hide status of popup
 */
export const toggleModal = (
  isModalOpen: boolean,
  initModal: boolean,
  setInitModal: (value: boolean) => void,
  setSelectedUser: (value: AssignGridDataType | null) => void,
  getAssignGridData: () => void,
  setIsModalOpen: (value: boolean) => void,
  dispatch: ThunkDispatch<any, any, any>
) => {
  dispatch(updateSelectedCandidate({}));
  if (isModalOpen) {
    setSelectedUser(null);
    getAssignGridData();
    setTimeout(() => {
      setInitModal(!initModal);
    }, 500);
  } else {
    setInitModal(!initModal);
  }
  setIsModalOpen(!isModalOpen);
};

export const getGridOption = (fulfilled: any) => {
  let gridOptions: GridOptionType[] = [];
  let response = fulfilled.payload?.response
    ? fulfilled?.payload?.response
    : [];
  if (response && Array.isArray(response)) {
    response.sort((a: any, b: any) => {
      return Number(a.gridid) < Number(b.gridid) ? -1 : 1;
    });
    response.forEach((element: any) => {
      gridOptions.push({
        // value: element.gridid,
        // label: `${element.gridid} - ${element.vname}`,
        value: element.gridid,
        label: element.gridid,
        villageId: element.vid,
        districtID: element.did,
      });
    });
  } else {
    gridOptions = [];
    response = [];
  }
  return { gridOptions, response };
};
export const findGridDetails = (
  selectedGrid: SelectOptionType,
  iAgriGridData: IAgriGridType[]
) => {
  let gridData: IAgriGridType = {
    gridid: '',
    polygon: '',
    vname: '',
    vid: '',
    state: '',
    sid: '',
  };
  if (iAgriGridData) {
    for (const element of iAgriGridData) {
      if (selectedGrid.value === element.gridid) {
        gridData = element;
        break;
      }
    }
  }
  return gridData;
};
/**
 * Find grids details and prepare data for polygons
 * @param selected
 */
export const findGridDetailsAndPolygonArray = (
  selected: SelectOptionType[],
  iAgriGridData: IAgriGridType[],
  setSelectedGridsDetails: (value: IAgriGridType[] | undefined) => void,
  setSelectedGridsLatLngArray: (value: any[]) => void
) => {
  if (iAgriGridData && selected?.length) {
    const latLngArrayForGrids: any = [];
    const duplicateIdArray: string[] = [];
    const gridDetailsArray: IAgriGridType[] = [];
    for (const element of selected) {
      const selectedGrid: SelectOptionType = element;
      if (!duplicateIdArray.includes(String(selectedGrid.value))) {
        duplicateIdArray.push(String(selectedGrid.value));
        const gridDetails = findGridDetails(selectedGrid, iAgriGridData);
        gridDetailsArray.push(gridDetails);
        const gridLatLngArray = getLatLngArray(gridDetails.polygon ?? '');
        latLngArrayForGrids.push(gridLatLngArray);
      }
    }
    setSelectedGridsDetails(gridDetailsArray);
    setSelectedGridsLatLngArray(latLngArrayForGrids);
  } else {
    setSelectedGridsLatLngArray([[], []]);
    setSelectedGridsDetails(undefined);
  }
};

export const checkMatchedGrid = (
  selectedGridIds: GridOptionType[],
  assignedgrids?: string
) => {
  let isMatch = false;
  if (!selectedGridIds || selectedGridIds.length === 0) {
    toast.error('Please select grids!');
  }

  const grids = selectedGridIds?.map((item: any) => ({
    gridId: Number(item.value),
    villageID: Number(item.villageId),
    districtID: Number(item.districtID),
  }));

  for (const element of grids) {
    if (assignedgrids?.includes(String(element))) {
      isMatch = true;
      toast.error('Selected grid has assigned already.');
      break;
    }
  }
  return { isMatch, grids };
};
